export default "__VITE_ASSET__SqqVNUVU__"